module.exports = __webpack_public_path__ + "static/media/home.d819a1ba.png";